
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductListingItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"realId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sku"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSoldOut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBestSeller"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lockdownText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blueTag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yellowTag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xLeftQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dealTypes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retailPrice"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPriceRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeFromDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeToDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saving"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"externalListingLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topLevelCategories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":590}};
    doc.loc.source = {"body":"fragment ProductListingItem on ProductInterface {\n  id\n  realId\n  sku\n  name\n  shortName\n  brand\n  isSoldOut\n  isBestSeller\n  lockdownText\n  blueTag\n  yellowTag\n  xLeftQuantity\n  dealTypes\n  retailPrice {\n    value\n    formattedValue\n  }\n  price {\n    value\n    formattedValue\n  }\n  minPrice {\n    value\n    formattedValue\n  }\n  hasPriceRange\n  position\n  activeFromDate\n  activeToDate\n  saving {\n    format\n    percent\n    fixed {\n      value\n      formattedValue\n    }\n  }\n  image {\n    id\n    url\n    path\n    label\n  }\n  externalListingLink\n  topLevelCategories {\n    id\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductListingItem"] = oneQuery(doc, "ProductListingItem");
        
